import React, { useState, useCallback, useContext } from "react";
import useApi from "../Api/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTshirt, faStar, faGuitar } from "@fortawesome/free-solid-svg-icons";
import AddArtist from "../Forms/AddArtist";
import AddProduct from "../Forms/AddProduct";
import UploadProduct from "../Forms/UploadProduct";
import AddEvent from "../Forms/AddEvent";
import useProducts from "../hooks/useProducts";
import { FilterContext } from "../FilterContextProvider";
import Logout from "../Auth/Logout";
import { UserContext } from "../Auth/UserContextProvider";

const Home = () => {
  const api = useApi();
  const { isAdmin } = useContext(UserContext);
  const [artists, setArtists] = useState([]);
  const [showArtistDrawer, setShowArtistDrawer] = useState(false);
  const [showManualForm, setShowManualForm] = useState(false);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [showEventForm, setShowEventForm] = useState(false);
  const fromHome = true;
  const { filterData } = useContext(FilterContext);

  const { getProducts, currentPage } = useProducts(false);

  const afterSubmit = () => {
    getProducts(currentPage);
  };

  const handleShowArtistDrawer = () => {
    setShowArtistDrawer(!showArtistDrawer);
  };

  const handleShowManualForm = () => {
    setShowManualForm(!showManualForm);
    setShowUploadForm(false);
  };

  const handleShowUploadForm = () => {
    setShowUploadForm(!showUploadForm);
    setShowManualForm(false);
  };

  const handleShowEventForm = () => {
    setShowEventForm(!showEventForm);
  };

  const getArtists = useCallback(() => {
    api.get(`/artists`).then((r) => {
      setArtists(r.data);
    });
  }, [api, setArtists]);

  return (
    <>
      <div className="text-black ml-24 h-14 border-b bg-white">
        <div className="flex flex-row mb-4 text-sm text-black h-14">
          {filterData.artist_name && (
            <div className="bg-blue-500 text-white h-14 flex p-4 font-semibold">
              {filterData.artist_name}
            </div>
          )}
          <Logout></Logout>
        </div>
      </div>
      <div className="flex h-full bg-gray-100 text-2xl">
        {showArtistDrawer && (
          <div className="mt-6 text-left">
            <AddArtist
              handleShowArtistDrawer={handleShowArtistDrawer}
              getArtists={getArtists}
              artists={artists}
            ></AddArtist>
          </div>
        )}
        {showManualForm && (
          <div className="mt-6 text-left">
            <AddProduct
              handleShowManualForm={handleShowManualForm}
              handleShowUploadForm={handleShowUploadForm}
              afterSubmit={afterSubmit}
              fromHome={fromHome}
            ></AddProduct>
          </div>
        )}
        {showUploadForm && (
          <div className="mt-6 text-left">
            <UploadProduct
              handleShowManualForm={handleShowManualForm}
              handleShowUploadForm={handleShowUploadForm}
              afterSubmit={afterSubmit}
              fromHome={fromHome}
            ></UploadProduct>
          </div>
        )}
        {showEventForm && (
          <div className="mt-14 text-left">
            <AddEvent
              handleShowEventForm={handleShowEventForm}
              fromHome={fromHome}
            ></AddEvent>
          </div>
        )}
        <div className="ml-24 w-full flex justify-center -mt-20 items-center flex-wrap">
          {isAdmin && (
            <button
              onClick={handleShowArtistDrawer}
              className="max-w-80 mr-6 px-14 py-20 bg-white rounded-lg shadow-xl"
            >
              <div className="mx-20 py-2 mb-4 bg-gray-200 text-blue-500 rounded-md">
                <FontAwesomeIcon icon={faGuitar} />
              </div>
              <p className="pb-1 font-medium">Add an Artist</p>
              <p className="text-xs mx-8 text-black tracking-normal">
                Quickly add an artist to the database
              </p>
            </button>
          )}
          <button
            onClick={handleShowManualForm}
            className="max-w-80 mr-6 px-14 py-20 bg-white rounded-lg shadow-xl"
          >
            <div className="mx-20 py-2 mb-4 bg-gray-200 text-blue-500 rounded-md">
              <FontAwesomeIcon icon={faTshirt} />
            </div>
            <p className="pb-1 font-medium">Add Inventory</p>
            <p className="text-xs mx-8 text-black tracking-normal">
              Manually add or import product for any artist
            </p>
          </button>
          <button
            onClick={handleShowEventForm}
            className="max-w-80 mr-6 px-14 py-20 bg-white rounded-lg shadow-xl"
          >
            <div className="mx-20 py-2 mb-4 bg-gray-200 text-blue-500 rounded-md">
              <FontAwesomeIcon icon={faStar} />
            </div>
            <p className="pb-1 font-medium">Add an Event</p>
            <p className="text-xs mx-8 text-black tracking-normal">
              Add an event to any artist's profile
            </p>
          </button>
        </div>
        <img
          src="/ctm_logo.png"
          alt="ctm_logo"
          className="absolute right-4 bottom-0 max-w-80 mb-4"
        />
      </div>
    </>
  );
};

export default Home;
